<template>
<!--  //TODO: figure out if we wanna show a text passed from the user or use a generic one? -->
  <mds-alert
    title="Login error"
    text="The login information are incorrect."
    variation="error"
    size="small"
    tinted="true"
    dismissible="false"
  />
</template>

<script>
import MDSAlert from '../imports'

export default {
  name: 'LoginFail'
}
</script>
